module.exports = __webpack_public_path__ + "static/media/cssda-innovation-Lukasz-Macon_08_12_2021.5e0727de.pdf";